import React, { Component } from 'react';
import { Alert } from 'reactstrap';

// Surfaces runtime errors in the builder instead of white-screening, and shows the
// message + component stack so issues can be diagnosed quickly.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
    // eslint-disable-next-line no-console
    console.error('[HomepageBuilder] render error:', error, info);
  }

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="animated fadeIn" style={{ padding: 16 }}>
        <Alert color="danger">
          <h5 className="mb-2"><i className="fa fa-exclamation-triangle" /> Homepage Builder hit an error</h5>
          <div style={{ fontFamily: 'monospace', fontSize: '.8rem', whiteSpace: 'pre-wrap' }}>{String(error && error.message ? error.message : error)}</div>
          {info && info.componentStack ? (
            <details style={{ marginTop: 8 }}>
              <summary style={{ cursor: 'pointer' }}>Component stack</summary>
              <div style={{ fontFamily: 'monospace', fontSize: '.72rem', whiteSpace: 'pre-wrap' }}>{info.componentStack}</div>
            </details>
          ) : null}
        </Alert>
      </div>
    );
  }
}
